import * as React from "react";
import Button from "./Button";
import Loader from "./Loader";
import StatusView from "./StatusView";

interface Props {
  loading?: boolean;
  error?: boolean;
  errorMessage?: string;
  onRetry?: () => void;
  retryText?: string;
  className?: string;
  customLoader?: React.ReactNode;
}
export default function LoaderContainer(props: React.PropsWithChildren<Props>) {
  const {
    children,
    error,
    loading,
    errorMessage = "Sorry, something went wrong.",
    onRetry,
    retryText,
    className,
    customLoader,
  } = props;

  if (!loading && !error) {
    return <>{children}</>;
  }

  return (
    <div
      tw="w-full h-full flex flex-col items-center justify-center"
      className={className}
    >
      {loading &&
        !error &&
        (customLoader ?? (
          <div tw="p-[30px]">
            <Loader />
          </div>
        ))}

      {error && (
        <StatusView
          status="warning"
          title={errorMessage}
          description="Please retry"
        >
          <Button
            variant="primary"
            text={retryText ?? "Retry"}
            tw="mt-[24px] mx-auto"
            onClick={onRetry}
          />
        </StatusView>
      )}
    </div>
  );
}
